<template>
    <div>
        <CustomFieldGroup
            v-for="grp in customFieldGroups"
            :key="`cfg-${grp.group}`"
            :custom-field-group="grp"
            :group-values="localValue[grp.group] || {}"
            @changed="handleCustomFieldGroupChanged"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomFieldGroup from './CustomFieldGroup';

export default {
    name: 'TeamMemberCustomFields',
    components: {
        CustomFieldGroup
    },
    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            localValue: {}
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        customFieldGroups() {
            return this.user.teamMemberCustomFieldDefinitions || [];
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(newVal) {
                // Clone the prop to avoid mutating it directly
                this.localValue = JSON.parse(JSON.stringify(newVal || {}));
            }
        }
    },
    methods: {
        handleCustomFieldGroupChanged({ group, groupValues }) {
            this.$set(this.localValue, group, groupValues);

            // Emit updated value so the parent can react accordingly
            this.$emit('changed', { ...this.localValue });
        }
    }
};
</script>
